import logAskAllTrailsFeedbackRated from '@alltrails/amplitude/events/logAskAllTrailsFeedbackRated';
import logAskAllTrailsFeedbackSubmitted from '@alltrails/amplitude/events/logAskAllTrailsFeedbackSubmitted';
import FeedbackCard, { type FeedbackCardCopy, type FeedbackCardSubmission } from '@alltrails/layout/components/FeedbackCard';
import { useAppSelector } from '@/utils/redux';

// hwandrew TODO: XPLR-204 translations
const copy: FeedbackCardCopy = {
  cancelButton: 'Cancel',
  dismissLabel: 'Dismiss',
  helpfulLabel: 'Helpful',
  modalTitle: 'Share your feedback',
  notHelpfulLabel: 'Not helpful',
  submitButton: 'Submit',
  subtitle: 'Your feedback helps us improve this feature',
  textAreaLabel: 'Your feedback',
  textAreaPlaceholder: 'Your feedback helps improve this feature',
  title: 'Was this helpful?'
};

type Props = {
  isChat?: boolean;
  requestId?: string;
};

/**
 * Thumbs up or down on an answer, just the thumbs in a chat. Keyed by the question's `requestId`, so each new question gets a
 * fresh, unrated card.
 */
const AskFeedback = ({ isChat, requestId }: Props) => {
  const sessionId: string | undefined = useAppSelector(state => state.ask.session?.id);

  const onRate = (helpfulRating: boolean) => {
    logAskAllTrailsFeedbackRated({
      feedback: helpfulRating ? 'helpful' : 'not helpful',
      query_id: requestId,
      session_id: sessionId
    });
  };

  // The modal only submits non-empty text, so this logs written feedback; ratings are logged by onRate
  const onSubmit = ({ feedback, helpfulRating }: FeedbackCardSubmission) => {
    logAskAllTrailsFeedbackSubmitted({
      comment: feedback,
      feedback: helpfulRating ? 'helpful' : 'not helpful',
      query_id: requestId,
      session_id: sessionId
    });
  };

  return <FeedbackCard copy={copy} onRate={onRate} onSubmit={onSubmit} variant={isChat ? 'compact' : 'card'} />;
};

export default AskFeedback;
